import { render, staticRenderFns } from "./AllInOneRegistration.vue?vue&type=template&id=61dcd7b7&scoped=true&"
import script from "./AllInOneRegistration.vue?vue&type=script&lang=js&"
export * from "./AllInOneRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dcd7b7",
  null
  
)

export default component.exports